

const timeSinceIntervals = [
  { label: 'year', seconds: 31536000 },
  { label: 'month', seconds: 2592000 },
  { label: 'day', seconds: 86400 },
  { label: 'hour', seconds: 3600 },
  // { label: 'minute', seconds: 60 },
  // { label: 'second', seconds: 1 }
];

export const readableTimeSince = (date) => {
  if (!date) return '';

  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  const interval = timeSinceIntervals.find(i => i.seconds < seconds);
  if (!interval) return '';
  if (interval.label === 'hour') return 'Less than a day ago';
  const count = Math.floor(seconds / interval.seconds);
  return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
};

export const readableDateTime = (utc) => {
  if (!utc) return '';
  return new Date(parseInt(utc)).toLocaleDateString(
    'en-au',
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'utc'
    }
  );
};

